import { render, staticRenderFns } from "./UserUpdateVATID.vue?vue&type=template&id=a9f459d4"
import script from "./UserUpdateVATID.vue?vue&type=script&lang=js"
export * from "./UserUpdateVATID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports